import {Component, ViewChild} from '@angular/core';
import {GritDeviceService} from "../../../services/grit/grit.device.service";
import {TabsService} from "../../../services/tabsService";
import {GritDynamicTableMode, GritDynamicTableType} from "../../../models/grit/grit.enums";
import {DeviceModel, DeviceSectorization} from "../../../models/grit/grit.device-model";
import {GritModel} from "../../../models/grit/grit.model";
import {GritDynamicTableComponent} from "../../../utils/grit/grit-dynamic-table/grit-dynamic-table.component";
import {GritApiService} from "../../../services/grit/grit.api.service";
import {GritUserRoleGroup, GritUserService} from "../../../services/grit/grit.user.service";
import {cloneDeep} from "lodash";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {
  AddDeviceSectorizationComponent
} from "../../../popup/grit/add-device-sectorization/add-device-sectorization.component";
import {sectorizationGraphDataGrit} from "../../../models/sectorizationGraphData";
import {GritUtils} from "../../../utils/grit/GritUtils";
import {
  SectorizationDisplayComponent
} from "../../../popup/sectorization-display/sectorization-display/sectorization-display.component";
import {GritFeature} from "../../../models/grit/grit.feature";
import {ModalControlService} from "../../../services/modal-control.service";
import {ModalConfirmationService} from "../../../services/modal-confirmation.service";
import {ReceiverModel} from "../../../models/grit/grit.receiver-model";
import {GritReceiverService} from "../../../services/grit/grit.receiver.service";
import { GritGroupsComponent } from 'src/app/utils/grit/grit-groups/grit-groups.component';

@Component({
  selector: 'app-receiver',
  templateUrl: './receiver.component.html',
  styleUrls: ['../../../app.component.scss', './receiver.component.scss'],
  standalone: false
})
export class ReceiverComponent {

  selectedReceiver : ReceiverModel = null;

  @ViewChild(GritDynamicTableComponent) table: GritDynamicTableComponent
  
  readonly groupsNotNull = GritGroupsComponent.groupsNotNull;

  constructor(
    protected receiverService : GritReceiverService,
    protected gritUserService : GritUserService,
    protected gritApiService : GritApiService,
    protected tabsService : TabsService,
    protected popupService : BsModalService,
    protected modalService: ModalControlService,
    protected modalConfirmation: ModalConfirmationService,
  ) {
  }

  showReceiver(model : GritModel<any>){
    if(model.id == this.selectedReceiver?.id){
      this.selectedReceiver = null;
    }
    else if(model.id == 0){
      this.selectedReceiver = model as ReceiverModel;
    }
    else{
      this.selectedReceiver = cloneDeep(model as ReceiverModel);
    }
  }

  addReceiver(){
    this.showReceiver(new ReceiverModel())
  }

  deleteReceiver(){
    this.modalConfirmation.showMesssageConfirmationModal(
      "Delete Receiver",
      "Do you want to delete the selected receiver?",
      "OK", "Cancel",
      () => {
        this.gritApiService.receiverDelete([this.selectedReceiver]).then(
          (receivers) => {
            receivers.forEach(receiver => {
              let i = this.receiverService.receivers.findIndex(d => d.id == receiver.id);
              if(i == -1) return;
              this.receiverService.receivers.splice(i, 1);

              this.selectedReceiver = null;
              this.table.models = this.receiverService.receivers
            });
            this.modalService.showMesssageModal(
              "Delete Receiver",
              "Successfully deleted the receiver.");
          },
          (error) => {
            console.error(error)
            this.modalService.showMesssageModal(
              "Delete Receiver Error",
              "Error deleting the receiver.");
          }
        )
      }
    );
  }

  saveReceiver(){
    this.modalConfirmation.showMesssageConfirmationModal(
      "Save Receiver",
      "Do you want to save the receiver?",
      "OK", "Cancel",
      () => {
        if(this.selectedReceiver?.id == 0){
          this.gritApiService.receiverCreate([this.selectedReceiver]).then(
            (receivers) => {
              this.receiverService.receivers.push(...receivers);
              this.selectedReceiver = null;
              this.table.models = this.receiverService.receiversSorted
            },
            (error) => {console.error(error)}
          )
        }
        else{
          this.gritApiService.receiverUpdate([this.selectedReceiver]).then(
            (receivers) => {
              receivers.forEach(receiver => {
                let i = this.receiverService.receivers.findIndex(d => d.id == receiver.id);
                if(i == -1) return;
                this.selectedReceiver = null;
                this.receiverService.receivers[i] = receiver;
              });

              this.table.models = this.receiverService.receiversSorted
            },
            (error) => {console.error(error)}
          )
        }
      }
    );
  }

  protected readonly GritDynamicTableType = GritDynamicTableType;
  protected readonly GritDynamicTableMode = GritDynamicTableMode;
  protected readonly DeviceModel = DeviceModel;
  protected readonly ReceiverModel = ReceiverModel;
  protected readonly GritUserRoleGroup = GritUserRoleGroup;
}
